import { getCharacterCount, getReadingTime, getSpeakingTime, getWordCount } from "../util/CounterUtil";
export class CounterType {
}
class Character extends CounterType {
    getLabel(text) {
        return getCountLabel(getCharacterCount(text), strings.counters.getCharacterPlural);
    }
}
class Word extends CounterType {
    getLabel(text) {
        return getCountLabel(getWordCount(text), strings.counters.getWordPlural);
    }
}
class ReadingTime extends CounterType {
    getLabel(text) {
        return `${toReadableTime(getReadingTime(text))} ${strings.readingTime}`;
    }
}
class SpeakingTime extends CounterType {
    getLabel(text) {
        return `${toReadableTime(getSpeakingTime(text))} ${strings.speakingTime}`;
    }
}
function getCountLabel(count, getPluralForm) {
    return `${count} ${getPluralForm(count)}`;
}
export function toReadableTime(seconds) {
    let string = `${seconds % 60} ${strings.sec}`;
    if (seconds >= 60)
        string = `${Math.floor(seconds / 60)} ${strings.min} ` + string;
    return string;
}
(function (CounterType) {
    CounterType.character = new Character();
    CounterType.word = new Word();
    CounterType.readingTime = new ReadingTime();
    CounterType.speakingTime = new SpeakingTime();
    CounterType.values = [CounterType.character, CounterType.word, CounterType.readingTime, CounterType.speakingTime];
    function valueOf(name) {
        if (isCounterType(name))
            return CounterType[name];
        return null;
    }
    CounterType.valueOf = valueOf;
    function isCounterType(tested) {
        return tested == "character" || tested == "word" || tested == "readingTime" || tested == "speakingTime";
    }
})(CounterType || (CounterType = {}));
